import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import App from './App.jsx'
import { log as debugLog } from './utils/logger'
import { isLwcCompactionCrash } from './core/lwcCrashGuard'
debugLog('BUILD_VERSION_2026_05_11_v3')

// Diagnóstico temporal (chart "Value is null"): congela un snapshot
// completo del estado de los indicadores/chart en cuanto salte ese error
// diferido de lightweight-charts, sin depender de breakpoints manuales en
// DevTools. Después del crash, en la consola, ejecutar:
//   copy(window.__crashSnapshot)
window.addEventListener('error', (e) => {
  // La firma exacta del bug upstream LWC #2044 la gestiona lwcCrashGuard
  // (la cuenta y la contiene). Un error contenido no debe generar snapshot
  // de diagnóstico: se ignora aquí y se deja que el guard haga su trabajo.
  if (isLwcCompactionCrash(e)) return
  const msg = e?.message || e?.error?.message || ''
  if (!/Value is null/i.test(msg)) return
  if (window.__crashSnapshot) return // solo el primero, para no sobrescribir con los siguientes (se repite en cada frame)
  window.__crashSnapshot = {
    message: msg,
    stack: e?.error?.stack,
    capturedAt: Date.now(),
    location: window.location.href,
    userAgent: navigator.userAgent,
    allIndicatorRenders: window.__allIndicatorRenders,
    lastRenderMeta: window.__lastRenderMeta,
    syncMarkersMeta: window.__syncMarkersMeta,
    renderContext: window.__renderContext,
    lastTickAt: window.__lastTickAt,
    isToggling: window.__chartControl?.isToggling,
    pendingDataVersion: window.__chartControl?.pendingDataVersion,
  }
  debugLog('%c[CRASH CAPTURADO] Ejecuta: copy(window.__crashSnapshot)', 'background:#dc2626;color:white;padding:4px 8px;font-weight:bold;')
}, true)

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
